// ChildNode.remove
if(!("remove" in Element.prototype)){
  Element.prototype.remove = function(){
    if(this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// /Users/remimichel/workspace/rwigo/psip/wp-content/themes/psip/node_modules/tiny-slider/src/helpers/childNode.remove.js
// module id = 155
// module chunks = 0